import React, { PropTypes } from 'react';
import FileSaver from 'file-saver';
import { dateFormat } from 'lib/format';

function prepareCsv(buckets) {
    let csvContent = 'Start Time,Event Name,Sport,League,Network,Link\r\n';
    buckets.forEach((bucket) => {
        const contents = bucket.contents;
        contents.forEach((content) => {
            if (!content.programmingData) {
                content.programmingData = {};
            }
            const { programmingData: { sport = '', league = '' }, name = '', utc = '' } = content;
            const { source: { name: sourceName = '' }, links: { web: webLink = '' } } = content.streams[0];
            const dateAndTime = dateFormat.dateFormat(utc, 'dateTime7');
            const row = `"${dateAndTime}","${name}",${sport},${league},${sourceName},${webLink}`;
            csvContent = `${csvContent}${row}\r\n`;
        });
    });
    return csvContent;
}

const DownloadLink = ({ text, buckets, fileName, mimeType = 'text/csv' }) => {
    const dataString = prepareCsv(buckets);
    function clickHandler(ev) {
        // File is not available on the server, so must be built in the browser
        const file = new File([dataString], fileName, { type: mimeType });
        ev.preventDefault();
        FileSaver.saveAs(file);
    }
    return (
        <a onClick={clickHandler}>
            {text}
        </a>
    );
};

DownloadLink.propTypes = {
    text: PropTypes.string,
    buckets: PropTypes.string,
    fileName: PropTypes.string,
    mimeType: PropTypes.string
};

export default DownloadLink;



// WEBPACK FOOTER //
// ./app/common/DownloadLink.js